import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/CollectionPage/CollectionPageAlfa.jsx");
;
import(/* webpackMode: "eager" */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/scrollToTopHook/ScrollToTop.jsx");
